// eslint-disable-next-line no-undef
export const relativeTime = require("dayjs/plugin/relativeTime");
// eslint-enable-next-line no-undef
